<template>
  <div>
    <b-card>
      <div>
        <div class="row">
          <div class="col-xs-6 col-md-6">
            <h3 class="text-left">Attendance Mobility Import</h3>
          </div>
        </div>

        <b-overlay :show="showoverlay_att" rounded="sm" class="mt-4">
          <div class="row clearfix mb-2">
            <div class="col-md-12">Click browse and upload file</div>
          </div>

          <b-form-file
              id="datafile_att"
              name="datafile_att"
              @change="getFileAttendance"
              accept=".xlsx,.xls"
          ></b-form-file>

          <br />
          <br />

          <b-button @click="uploadFile">Upload File</b-button>

          <div v-if="errormsg_att">
            <div v-if="errormsg_att.length > 0" class="alert alert-danger my-3">
              Total error {{ errormsg_att.length }}
            </div>
            <ul class="list-group">
              <li class="list-group-item list-group-item-danger" v-for="error in errormsg_att" :key="error">
                {{ error }}
              </li>
            </ul>
          </div>
        </b-overlay>
      </div>
    </b-card>

    <b-card class="mt-4">
      <div>
        <div class="row">
          <div class="col-xs-6 col-md-6">
            <h3 class="text-left">Compensatory Leave Import</h3>
          </div>
        </div>

        <b-overlay :show="showoverlay_comp" rounded="sm" class="mt-4">
          <div class="row clearfix mb-2">
            <div class="col-md-12">Click browse and upload file</div>
          </div>

          <b-form-file
              id="datafile_comp"
              name="datafile_comp"
              @change="getFileCompen"
              accept=".xlsx,.xls"
          ></b-form-file>

          <br />
          <br />

          <b-button @click="uploadCompenFile">Upload File</b-button>

          <div v-if="errormsg_comp">
            <div v-if="errormsg_comp.length > 0" class="alert alert-danger my-3">
              Total error {{ errormsg_comp.length }}
            </div>
            <ul class="list-group">
              <li class="list-group-item list-group-item-danger" v-for="error in errormsg_comp" :key="error">
                {{ error }}
              </li>
            </ul>
          </div>
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      empfile_att: null,
      empfile_comp: null,

      errormsg_att: [],
      errormsg_comp: [],

      showoverlay_att: false,
      showoverlay_comp: false,
    };
  },
  methods: {
    getFileAttendance(event) {
      this.empfile_att = event.target.files[0];
    },

    getFileCompen(event) {
      this.empfile_comp = event.target.files[0];
    },

    uploadFile: function () {
      this.showoverlay_att = true;
      this.errormsg_att = [];

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      const data = new FormData();
      data.append("empfile", this.empfile_att);

      axios
          .post(this.$api_url + "/la/attendance/import", data, config)
          .then((response) => {
            this.showoverlay_att = false;
            this.$bvToast.toast("Successfully imported!", {
              variant: "success",
              title: "Success",
              solid: true,
            });
          })
          .catch((error) => {
            this.showoverlay_att = false;
            this.serverError(error);
          });
    },

    uploadCompenFile: function () {
      this.showoverlay_comp = true;
      this.errormsg_comp = [];

      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      const data = new FormData();
      data.append("empfile", this.empfile_comp);

      axios
          .post(this.$api_url + "/la/compensatory-leave/import", data, config)
          .then((response) => {
            this.showoverlay_comp = false;
            this.$bvToast.toast("Successfully imported!", {
              variant: "success",
              title: "Success",
              solid: true,
            });
          })
          .catch((error) => {
            this.showoverlay_comp = false;
            this.serverError(error);
          });
    },
  },
};
</script>